import { useMutation } from '@apollo/client';
import { REDEEM_MG_UNLOCK_CODE } from 'graphql/mutations/redeemMemberGroupUnlockCode';
import React, { useCallback } from 'react';
import { usePermitStore } from 'stores/permitStore';
import {
  Mutation,
  MutationRedeemUnlockCodeArgs,
} from 'types/generatedSchemaTypes';
import { READ_BENEFITS } from '@queries/readBenefits.tsx';
import UnlockPmcBase from './UnlockPmcBase';
import { useUnlockPmc } from 'hooks/useUnlockPmc';

const UnlockMemberGroupPmcModalContent: React.FC = () => {
  const {
    t,
    pmcId,
    unlockCode,
    errorMessage,
    setErrorMessage,
    handleInputChange,
    handleCancel,
    handleSuccess,
  } = useUnlockPmc();

  const selectedParkZoneBenefitValue = usePermitStore(
    (state) => state.selectedParkZoneBenefit
  );
  const benefitUid = selectedParkZoneBenefitValue?.benefitUid;
  const benefitTargetType = selectedParkZoneBenefitValue?.benefitTargetType;

  const [redeemUnlockCode, { loading }] = useMutation<
    Mutation,
    MutationRedeemUnlockCodeArgs
  >(REDEEM_MG_UNLOCK_CODE, {
    refetchQueries: [
      {
        query: READ_BENEFITS,
      },
    ],
    awaitRefetchQueries: true,
    onCompleted: (data) => {
      if (
        (data?.redeemUnlockCode?.status === 'UNLOCK_CODE_REDEEM_DUPLICATE' ||
          data?.redeemUnlockCode?.status === 'UNLOCK_CODE_REDEEMED') &&
        pmcId
      ) {
        handleSuccess(false);
      } else {
        setErrorMessage(t('permit.unlockPMC.incorrect'));
      }
    },
    onError: () => {
      setErrorMessage(t('permit.unlockPMC.incorrect'));
    },
  });

  const handleUnlock = useCallback(async () => {
    setErrorMessage(null);

    if (!pmcId || !benefitUid || !benefitTargetType) {
      setErrorMessage(t('permit.unlockPMC.incorrect'));
      return;
    }

    await redeemUnlockCode({
      variables: {
        benefitUid: benefitUid,
        benefitTargetType: benefitTargetType,
        benefitTargetUid: pmcId,
        targetType: 'MEMBER_GROUP',
        input: {
          code: unlockCode,
        },
      },
    });
  }, [
    pmcId,
    benefitUid,
    benefitTargetType,
    redeemUnlockCode,
    unlockCode,
    t,
    setErrorMessage,
  ]);

  return (
    <UnlockPmcBase
      unlockCode={unlockCode}
      errorMessage={errorMessage}
      loading={loading}
      onUnlock={handleUnlock}
      onCancel={handleCancel}
      onInputChange={handleInputChange}
    />
  );
};

export default UnlockMemberGroupPmcModalContent;
